import { render, staticRenderFns } from "./exercises.vue?vue&type=template&id=37236ae8"
import script from "./exercises.vue?vue&type=script&lang=js"
export * from "./exercises.vue?vue&type=script&lang=js"
import style0 from "./exercises.vue?vue&type=style&index=0&id=37236ae8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports